import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-car-insurance-navbar',
  imports: [CommonModule,RouterModule,TranslatePipe],
  templateUrl: './car-insurance-navbar.component.html',
  styleUrl: './car-insurance-navbar.component.scss'
})
export class CarInsuranceNavbarComponent {
menuOpen = false;
  activeSubmenu: string | null = null;
  lang!: string;
  constructor(public router: Router, public route: ActivatedRoute) {}
  ngOnInit() {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const possibleLang = pathSegments[0];
    const supportedLangs = ['en', 'vi'];
    this.lang = supportedLangs.includes(possibleLang) ? possibleLang : 'en';
  }

  /** ✅ Toggle mobile menu */
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    this.activeSubmenu = null;
  }

  /** ✅ Toggle submenu dropdowns */
  toggleSubmenu(menu: string) {
    this.activeSubmenu = this.activeSubmenu === menu ? null : menu;
  }

  /** ✅ Handle navigation correctly */
  onNav(path: string) {
    this.menuOpen = false; 
    this.activeSubmenu = null;
    const fullUrl =
      this.lang === 'vi'
        ? `https://www.livwell.vn/${this.lang}/${path}`
        : `https://www.livwell.vn/${path}`;

    window.location.href = fullUrl;
  }

}